import {
  adminGymAiLimitsSchema,
  type AdminGymAiLimits,
  type AdminGymAiLimitsUpdate,
} from '@steado/admin-contract/gyms';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/** A gym's AI caps, this month's use against them, and what the AI cost. */
export function gymAiLimitsQueryOptions(api: ApiClient, gymId: string) {
  return queryOptions({
    queryKey: ['admin', 'gym', gymId, 'ai-limits'],
    queryFn: (): Promise<AdminGymAiLimits> =>
      api.request({ path: `/admin/gyms/${gymId}/ai-limits`, schema: adminGymAiLimitsSchema }),
  });
}

/** Sets or clears overrides; answers with the same shape as the read. */
export function updateGymAiLimits(
  api: ApiClient,
  gymId: string,
  body: AdminGymAiLimitsUpdate,
): Promise<AdminGymAiLimits> {
  return api.request({
    path: `/admin/gyms/${gymId}/ai-limits`,
    method: 'PUT',
    body,
    schema: adminGymAiLimitsSchema,
  });
}
